import { render, staticRenderFns } from "./trialV2.vue?vue&type=template&id=3da01e4a&scoped=true&"
import script from "./trialV2.vue?vue&type=script&lang=js&"
export * from "./trialV2.vue?vue&type=script&lang=js&"
import style0 from "./trialV2.vue?vue&type=style&index=0&id=3da01e4a&lang=scss&scoped=true&"
import style1 from "./trialV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da01e4a",
  null
  
)

export default component.exports